import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

//import theme from '@ecp/common/src/style/theme/default';
import { FlexBox, FlexBoxButton } from '@ecp/common/src/layouts/flex/styled';
import ButtonUnstyled from '@ecp/common/src/components/unstyled/button/ButtonUnstyled';
import useNumberIndicator from '@ecp/common/src/components/input/useNumberIndicator';

import { StyledInput } from './Input';
import NumberInput from './NumberInput';

const NumberIndicatorWrapper = styled(FlexBox)`
  border: ${(props) => props.theme.component.numberIndicator.border} solid
    ${(props) => props.theme.color.line.background};
  border-radius: ${(props) => props.theme.component.numberIndicator.borderRadius};
  width: 100px;
  height: 30px;
  background: ${(props) => props.theme.component.numberIndicator.background};
`;

const BlankButtonRoot = styled(FlexBoxButton).attrs(({ disabled, style }) => ({
  style: {
    ...style,
    cursor: disabled ? 'auto' : 'pointer',
  },
}))`
  width: 30px;
  height: 30px;
  border: ${(props) => props.theme.component.numberIndicator.button.border};
  border-radius: ${(props) => props.theme.component.numberIndicator.button.borderRadius};
  background: ${(props) => props.theme.component.numberIndicator.button.background};
  justify-content: center;
  user-select: none;
`;

const NumberIndicatorRoot = styled(FlexBox)`
  width: ${(props) => props.theme.component.numberIndicator.width};
  padding: ${(props) => props.theme.component.numberIndicator.padding};
  height: 30px;
  ${(props) => props.theme.component.input.defaultBorder}
`;

const NumberIndicatorInput = styled(StyledInput)`
  width: 32px;
  text-align: center;
  font-size: ${(props) => props.theme.font.size.basic};
  ${({ fontWeight }) => (fontWeight ? `font-weight: ${fontWeight}` : '')}
`;

const NumberIndicator = (props) => {
  const { disabled, value, handleChange, handleMinus, handlePlus, numberInputProps } = useNumberIndicator(props);

  return (
    <NumberIndicatorWrapper>
      <ButtonUnstyled
        rootComponent={BlankButtonRoot}
        disabled={disabled}
        onClick={handleMinus}
        ariaLabel="수량 1개 감소"
      >
        -
      </ButtonUnstyled>
      <NumberInput
        clearable={false}
        format={false}
        value={value}
        onChange={handleChange}
        inputComponent={NumberIndicatorInput}
        rootComponent={NumberIndicatorRoot}
        {...numberInputProps}
      />
      <ButtonUnstyled
        rootComponent={BlankButtonRoot}
        disabled={disabled}
        onClick={handlePlus}
        ariaLabel="수량 1개 증가"
      >
        +
      </ButtonUnstyled>
    </NumberIndicatorWrapper>
  );
};

NumberIndicator.displayName = 'NumberIndicator';

NumberIndicator.propTypes = {
  value: PropTypes.number,
  minValue: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default NumberIndicator;
